import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                  <i className="ri-play-circle-fill text-white text-xl"></i>
                </div>
                <span className="text-lg font-bold font-heading text-white">91在线视频</span>
              </div>
              <p className="text-background-400 text-sm leading-relaxed">
                汇聚国产影视精华，畅享高清视听盛宴。<br />
                免费在线观看国产电影、电视剧、综艺、纪录片等优质内容。
              </p>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4 text-sm">
                <a href="/category/movie" className="hover:text-primary-400 transition-colors">影视分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.filter(c => c.slug !== 'all').map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-background-400 hover:text-white text-sm transition-colors whitespace-nowrap"
                    >
                      <i className={`${cat.icon} mr-2 text-xs`}></i>
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4 text-sm">
                <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-background-400 hover:text-white text-sm transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-background-400 hover:text-white text-sm transition-colors">
                    联系方式
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-background-400 hover:text-white text-sm transition-colors">
                    常见问题
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-background-400 hover:text-white text-sm transition-colors">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-background-400 hover:text-white text-sm transition-colors">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-semibold mb-4 text-sm">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-background-400 text-sm">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@91onlinevideo.com</span>
                </li>
                <li className="flex items-center gap-2 text-background-400 text-sm">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-9191</span>
                </li>
                <li className="flex items-center gap-2 text-background-400 text-sm">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区建国路88号</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} <strong>91在线视频</strong> 版权所有 | 国产电影电视剧综艺免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-white text-xs transition-colors" rel="nofollow">用户协议</a>
            <a href="#" className="text-background-500 hover:text-white text-xs transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-500 hover:text-white text-xs transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}